import { Config, ITenant } from '../../../pages/AbmLocalPage/types'

export const TENANT_LASALADA_PATH = 'salada'
export const CONFIG_WHATSAPP_SOPORTE = 'whatsapp_soporte'

export const tenantHabilitaContactoSoporte = (tenant: ITenant): boolean => {
  return tenant?.path === TENANT_LASALADA_PATH
}

export const esLocalPendiente = (statusFlags: string): boolean => {
  return statusFlags !== 'A' && statusFlags !== 'R'
}
